// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__DummyTable from "../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__PageNav from "../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Payroll from "../../grpc/Payroll.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Search from "../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../components/molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (openMenu) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const match$1 = React.useState(function () {
          return 1;
        });
    const setPage = match$1[1];
    const page = match$1[0];
    const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Payroll.PayoutService.grid, undefined);
    const grid = match$2[0];
    const count = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
    const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
            title: "Выплаты",
            openMenu: openMenu
          }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
            title: "Выплаты"
          });
    const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */0 : Stdlib__List.mapi((function (i, item) {
              const post_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(item.post_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
              const e = item.employee;
              const employeeData = e !== undefined ? e : ({
                    id: "",
                    serial_id: 0,
                    tin: "",
                    family_name: "",
                    given_name: "",
                    patronymic_name: "",
                    birthday_date: undefined,
                    address: undefined,
                    email: "",
                    phone: "",
                    create_time: undefined,
                    update_time: undefined,
                    employment: undefined
                  });
              const match = item.destination_txn;
              const cardTransfer = typeof match === "string" ? ({
                    id: "",
                    state: "",
                    payout_txn_type: "",
                    payout_txn_id: "",
                    post_time: undefined,
                    process_time: undefined,
                    saved_card_id: "",
                    card_number_six: "",
                    card_number_four: "",
                    card_issuer_network: undefined,
                    card_issuer_bank: undefined,
                    currency_code: /* CURRENCY_UNSPECIFIED */0,
                    sent_amount: "",
                    fee_amount: "",
                    total_amount: "",
                    cancel_time: undefined,
                    cancel_reason_code: "",
                    cancel_reason_message: "",
                    payout_txn_refnum: ""
                  }) : match.VAL;
              const match$1 = cardTransfer.state;
              let tmp;
              switch (match$1) {
                case "cancelled" :
                    tmp = JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5",
                                  src: StaticAsset.src("/static/icons/cancelled.svg")
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "ml-2 text-gray-medium",
                                  children: "Отменен"
                                })
                          ],
                          className: "flex items-center"
                        });
                    break;
                case "failed" :
                    tmp = JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5",
                                  src: StaticAsset.src("/static/icons/failed.svg")
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "ml-2 text-alert",
                                  children: "Ошибка"
                                })
                          ],
                          className: "flex items-center"
                        });
                    break;
                case "processed" :
                    tmp = JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5",
                                  src: StaticAsset.src("/static/icons/done-20.svg")
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "ml-2 text-success",
                                  children: "Успешно"
                                })
                          ],
                          className: "flex items-center"
                        });
                    break;
                case "pending" :
                case "sent" :
                    tmp = JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5",
                                  src: StaticAsset.src("/static/icons/pending.svg")
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "ml-2 text-links",
                                  children: "В обработке"
                                })
                          ],
                          className: "flex items-center"
                        });
                    break;
                default:
                  tmp = null;
              }
              const bank = cardTransfer.card_issuer_bank;
              let tmp$1;
              if (bank !== undefined) {
                tmp$1 = JsxRuntime.jsx("img", {
                      className: "w-5",
                      alt: bank.name,
                      src: bank.icon_url
                    });
              } else {
                const network = cardTransfer.card_issuer_network;
                tmp$1 = network !== undefined ? JsxRuntime.jsx("img", {
                        className: "w-5",
                        alt: network.icon_alt_url,
                        src: network.icon_url
                      }) : null;
              }
              const cells_0 = {
                body: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            children: employeeData.family_name + (" " + (employeeData.given_name + (" " + employeeData.patronymic_name)))
                          }),
                      className: "flex-col"
                    }),
                style: "text-left col-span-2"
              };
              const cells_1 = {
                hd: {
                  body: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: MelNumeral.format({
                                    NAME: "Str",
                                    VAL: item.amount
                                  }) + (" " + "₸")
                            }),
                        className: "flex-col"
                      }),
                  style: ""
                },
                tl: {
                  hd: {
                    body: "0",
                    style: ""
                  },
                  tl: {
                    hd: {
                      body: JsxRuntime.jsx("div", {
                            children: tmp,
                            className: "py-2.5"
                          }),
                      style: ""
                    },
                    tl: {
                      hd: {
                        body: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      tmp$1,
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "ml-2 text-black",
                                            children: "••••" + ("  " + cardTransfer.card_number_four)
                                          })
                                    ],
                                    className: "flex items-center"
                                  }),
                              className: "py-2.5"
                            }),
                        style: ""
                      },
                      tl: {
                        hd: {
                          body: post_time,
                          style: "justify-end"
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
              const cells = {
                hd: cells_0,
                tl: cells_1
              };
              const Key = String(i);
              return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
                          cells: cells,
                          route: contextRoute({
                                TAG: /* Payroll */6,
                                _0: {
                                  TAG: /* Payouts */1,
                                  _0: {
                                    TAG: /* View */0,
                                    _0: item.id
                                  }
                                }
                              })
                        }, Key);
            }), grid.VAL);
    return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                header: header,
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Search.make, {
                              dispatch: match$2[1],
                              page: page,
                              setPage: setPage,
                              expand: {
                                hd: "employee",
                                tl: /* [] */0
                              },
                              showFilter: true,
                              className: Cn.on("hidden", count <= 0)
                            }),
                        typeof grid === "string" ? (
                            grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                          ) : (
                            grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                                                    header: count <= 0 ? /* [] */0 : ({
                                                          hd: {
                                                            name: "ФИО",
                                                            style: "col-span-2"
                                                          },
                                                          tl: {
                                                            hd: {
                                                              name: "Сумма",
                                                              style: ""
                                                            },
                                                            tl: {
                                                              hd: {
                                                                name: "Комиссия",
                                                                style: ""
                                                              },
                                                              tl: {
                                                                hd: {
                                                                  name: "Статус",
                                                                  style: ""
                                                                },
                                                                tl: {
                                                                  hd: {
                                                                    name: "Способ оплаты",
                                                                    style: ""
                                                                  },
                                                                  tl: {
                                                                    hd: {
                                                                      name: "Дата",
                                                                      style: "text-right"
                                                                    },
                                                                    tl: /* [] */0
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }),
                                                    rows: rows,
                                                    styles: "flex-1 bg-white grid-cols-[repeat(7,_auto)] lg:grid-cols-7 overflow-y-auto auto-rows-min"
                                                  }),
                                              count <= 0 ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "h-30",
                                                              alt: "buhta-zero-items",
                                                              src: StaticAsset.src("/static/icons/zero-items.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PLarge.make, {
                                                              className: "mt-6 w-[328px] text-asphalt text-center",
                                                              children: "В вашем предприятии пока нет выплат"
                                                            })
                                                      ],
                                                      className: "flex flex-col items-center col-span-3 mt-74"
                                                    }) : null
                                            ],
                                            className: "flex-1 overflow-auto"
                                          }),
                                      count <= 0 ? null : JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                                              page: page,
                                              setPage: setPage,
                                              currentRecords: count
                                            })
                                    ]
                                  }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                          )
                      ],
                      className: "flex flex-col w-full"
                    })
              });
  };
}

function PayoutsPage(Props) {
  return make(Props.org)(Props.openMenu);
}

const make$1 = PayoutsPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
